var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.x && _vm.y)?_c('div',{staticClass:"app-cursor-tooltip",style:(_vm.tooltipStyle)},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }